import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

function Analytics({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 22 24' {...props}>
      <Path
        d='M4.69141 6.56545H15.7659'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.69141 11.5015H10.8439'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.7615 13.6915L12.7557 17.9599L9.04443 16.1063L6.69381 19.0121'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M16.1816 16.1216L15.7607 13.6968L13.3359 14.1177'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Rect
        x='1'
        y='1.03125'
        width='19.688'
        height='22.1491'
        rx='2'
        stroke={color}
        fill={fill}
        strokeWidth='1.5'
      />
    </IconBase>
  )
}

Analytics.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Analytics
